import styles from './placeholder-loader.module.css';

// to use, wrap component in a div with fixed width and height.
const Placeholder = ({ isDarkBackground = false }) => {
  return isDarkBackground ? (
    <div className={styles.placeholder} data-testid="placeholder"></div>
  ) : (
    <div className={styles.dark_placeholder} data-testid="placeholder"></div>
  );
};

export default Placeholder;
